/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'
import useAppStore from '@/store/useAppStore'
import { shallow } from 'zustand/shallow'

interface Params {
  topicID: string
  noteID: string
  comment: string
}

export const useAddNoteComment = () => {
  const axios = useContext(AxiosContext)
  const { updateTopicList } = useAppStore()
  const [topicList] = useAppStore((state) => [state.home.topicList], shallow)

  const addNoteComment = (params: Params) => {
    const topic = topicList[params.topicID]
    // Album Lightbox comments (useAlbumComments) never load their topic into
    // this legacy store — they fetch through a dedicated hook into local
    // state instead. Skip the optimistic store write there; the API call
    // above already saved the comment either way. Previously this read
    // topic.totalComments before the topic existence check, crashing with
    // "Cannot read properties of undefined (reading 'totalComments')" and
    // making a comment that had actually saved look like it failed.
    if (!topic) return
    const commentsCount = `${Number(topic.totalComments) + 1}`

    const updatedNotes = topic.notes?.map((i) => {
      if (i.noteID == params.noteID) {
        return {
          ...i,
          comments: i.comments + 1,
        }
      } else {
        return i
      }
    })

    updateTopicList({
      [params.topicID]: {
        ...topicList[params.topicID],
        notes: updatedNotes,
        totalComments: commentsCount,
      },
    })
  }

  return useMutation({
    mutationKey: [ReactQueryKeys.INTERACT_ALBUM],
    mutationFn: async (params: Params) => {
      const response = await axios.api.post('ajax/topics', {
        requestType: 'topicNoteInteract',
        interactionType: '2',
        interaction: '0',
        ...params,
        format: 'json',
      })
      addNoteComment(params)
      return response.data
    },
  })
}
